import { Container, Row, Col, Spinner, Table, Button, Modal } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { AiOutlineLeft, AiFillCamera } from 'react-icons/ai'
import { Link, useParams } from 'react-router-dom'
import Actions from "../redux/actions";
import API from '../api/api'

export default function PhishingUrlsViewer(props) {

    const { id } = useParams()

    const user = useSelector(state => state.user)
    const accounts = useSelector(state => state.accounts)
    const phishingUrls = useSelector(state => state.phishingUrls)
    const [phishingUrl, setPhishingUrl] = useState()
    const [loading, setLoading] = useState(true)
    const [imageLoading, setImageLoading] = useState(false)

    const [showWarning, setShowWarning] = useState(false)
    const [showFullScreen, setShowFullScreen] = useState(false)

    const dispatch = useDispatch()
    useEffect(() => {

        document.title = 'ScamWall | Phishing Url'
        if (phishingUrls) {
            setPhishingUrl(phishingUrls.find(bl => bl._id === id))
            setLoading(false)
        } else {
            _setup()
        }

    }, [phishingUrls])


    const _setup = async () => {
        dispatch(Actions.setPhishingUrls(await API.getPhishingUrls()))
    }

    const _getImage = async () => {
        setImageLoading(true)
        const res = await API.getScreenShot(phishingUrl._id)
        if (res.isError) {
            dispatch(Actions.setToast('🚨 ERROR, Url Does Not Exists Anymore', 'Scammers take down sites when they get detected'))
        } else {
            dispatch(Actions.updatePhishingUrl(res.unlockCode))
        }
        setImageLoading(false)
    }

    const _approve = async () => {
        const res = await API.approveUrl(phishingUrl.url)
        if (res.isError) {
            dispatch(Actions.setToast('🚨 ERROR NOT AUTHORIZED', 'Something went wrong'))
        } else {
            if (user._id === phishingUrl.userId) {
                dispatch(Actions.setUser(res.user))
            } else {
                dispatch(Actions.updateAccount(res.user))
            }

            dispatch(Actions.setToast('✅ URL Whitelisted', 'This user will now be able to access this URL'))

        }

    }




    return (
        <Container fluid className='pt-4 ps-4 m-0 text-center'>
            <div className='text-start'>
                <Link variant='link' to='/phishing' className='text-start'><AiOutlineLeft /> Go Back</Link>
            </div>


            {loading && <div className='text-center my-3'><Spinner animation='border' /></div>}


            {!loading && <Row className='mt-3'>
                <Col md={7} className='mx-auto border rounded shadow p-4 h-100'>
                    <h2>Review the Link</h2>
                    <p>Be careful clicking the link, for your security, you may click "Get Screenshot" below to receive a screenshot of homepage.</p>
                    <Button variant='primary' disabled={loading || imageLoading} onClick={_getImage} >Get Screenshot <AiFillCamera /></Button>
                    {imageLoading && <>
                        <div className='text-center my-3'><Spinner animation='border' /></div>
                        <p className='text-primary mt-0'><small>Getting Screenshot of Homepage. This may take up to 30 seconds</small></p>
                    </>}

                    {phishingUrl?.userId !== user?._id && <>
                        <p className='mb-0 mt-2 text-center'><b>User:</b></p>
                        <p>{accounts?.find(acc => acc?._id === phishingUrl?.userId)?.fName}  {accounts?.find(acc => acc?._id === phishingUrl?.userId)?.lName}</p>
                    </>}
                    {phishingUrl?.userId === user?._id && <>
                        <p className='mb-0 mt-2 text-center'><b>User:</b></p>
                        <p>{user?.fName}  {user?.lName}</p>
                    </>}
                    <p className='mb-0 mt-2 text-center'><b>Blocked URL:</b></p>
                    <p className='link text-primary' onClick={() => setShowWarning(true)} style={{cursor : 'pointer', textDecoration : 'underline'}}>{phishingUrl.url}</p>
                    <p className='mb-0 mt-2 text-center'><b>Access Date:</b></p>
                    <p>{new Date(phishingUrl?.createdAt).toLocaleString('en-US', { timeStyle: 'medium', dateStyle: 'medium' })}</p>
                    {phishingUrl?.hasImgUrl && <>
                        <p className='mb-0 mt-2 text-center'><b>ScreenShot:</b></p>
                        <Row className='justify-content-center'>
                            <Col md={12}>
                                <img onClick={() => setShowFullScreen(true)} style={{ cursor: 'pointer' }} className='img-fluid border rounded' src={`https://scamwall-email-photos.s3.amazonaws.com/homepage-screenshots/${user?._id}/${phishingUrl?._id}.png`} alt="Screenshot of link" />
                                <p className='mt-0'><small>(Click Image to Enlarge)</small></p>
                            </Col>
                        </Row>
                    </>}

                    <Button variant='success text-white' onClick={_approve}>Approve URL</Button>
                </Col>
            </Row>}


            <Modal show={showWarning} onHide={() => setShowWarning(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Warning! You Are About to Go to a Potentially Dangerous Site!</Modal.Title>
                </Modal.Header>
                <Modal.Body>You may put your computer in harms way by going to this URL! You can see the homepage of this site instead by clicking the <b className='text-primary'>"Get Screenshot"</b> button above. <br /> If you would like to visit this site anyway, you assume all risk.</Modal.Body>
                <Modal.Footer>
                    <Button variant="link noDecoration" onClick={() => window.location.href = phishingUrl.url}>
                        Go to URL
                    </Button>
                    <Button variant="primary" onClick={() => setShowWarning(false)}>
                        Back to Safety
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showFullScreen} size='lg' onHide={() => setShowFullScreen(false)} >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <img className='img-fluid' src={`https://scamwall-email-photos.s3.amazonaws.com/homepage-screenshots/${user?._id}/${phishingUrl?._id}.png`} alt="Screenshot of link" />
                </Modal.Body>

            </Modal>



        </Container >
    )
}